import React from "react";
import Contact from "../sections/Contact";

const ContactPage = () => (
  <div data-testid="contact-page" className="pt-32 md:pt-40">
    <Contact />
  </div>
);

export default ContactPage;
